<template>
  <v-dialog
      v-model="dialog"
      max-width="320"
      persistent
  >
    <v-list
        class="py-2"
        color="primary"
        elevation="12"
        rounded="lg"
    >
      <v-list-item
          prepend-icon="$vuetify-outline"
          title="دریافت اطلاعات از سرور"
      >
        <template v-slot:prepend>
          <div class="pe-4">
            <v-icon color="primary" size="x-large"></v-icon>
          </div>
        </template>

        <template v-slot:append>
          <v-progress-circular
              color="primary"
              indeterminate="disable-shrink"
              size="16"
              width="2"
          ></v-progress-circular>
        </template>
      </v-list-item>
    </v-list>
  </v-dialog>
  <v-main class="main">
    <div style="padding: 30px 15px">
      <h2 style="text-align: center;color: #1fa29d;font-weight: 800">آدرس گیرنده :</h2>
      <div class="col-12">
        <div class="col-6 float-right text-center type1 addG" @click="settype(1)" style="color: #1fa29d">
          <div>گیرنده خودم</div>
        </div>
        <div class="col-6 float-right text-center type2 addG" @click="settype(2)" style="color: #1fa29d">
          <div>گیرنده دیگران</div>
        </div>
      </div>
      <div class="clearfix"></div>
     <div v-if="allAddress.data.length==0">
       <div class="col-12 " v-if="type==1" style="border: 1px dashed #ccc">
         <div class="col-12" style="margin: 5px 0">
           <div class="col-4 float-right text-center" style="padding: 10px 0">
             نام:
           </div>
           <div class="col-7 float-right" style="padding: 10px 0">
             <input type="text" v-model="name" class="form-control"/>
           </div>
         </div>
         <div class="col-12" style="margin: 5px 0">
           <div class="col-4 float-right text-center" style="padding: 10px 0">
             نام خانوادگی:
           </div>
           <div class="col-7 float-right" style="padding: 10px 0">
             <input type="text" v-model="family" class="form-control"/>
           </div>
         </div>
         <div class="col-12" style="margin: 5px 0">
           <div class="col-4 float-right text-center" style="padding: 10px 0">
             موبایل:
           </div>
           <div class="col-7 float-right" style="padding: 10px 0">
             <input type="text" v-model="mobile" readonly class="form-control"/>
           </div>
         </div>
         <div class="col-12" style="margin: 5px 0">
           <div class="col-4 float-right text-center" style="padding: 10px 0">
             استان:
           </div>
           <div class="col-7 float-right" style="padding: 10px 0">
             <select class="form-select" v-model="stete_id" @change="getCity" >
               <option value="">انتخاب کنید</option>
               <template v-for="(stete_list, index)  in stete.data" :key="index">
                 <option  :value="stete_list.id" v-text="stete_list.fa"></option>
               </template>
             </select>
           </div>
         </div>
         <div class="clearfix"></div>
         <div class="col-12" style="margin: 5px 0">
           <div class="col-4 float-right text-center" style="padding: 10px 0">
             شهر:
           </div>
           <div class="col-7 float-right" style="padding: 10px 0">
             <select class="form-select" v-model="city_id">
               <option value="">انتخاب کنید</option>
               <template v-for="(stete_list, index)  in city.data" :key="index">
                 <option  :value="stete_list.id" v-text="stete_list.fa"></option>
               </template>
             </select>
           </div>

         </div>
         <div class="clearfix"></div>
         <div class="col-12 address" style="margin: 5px 0">
           <div class="col-1 float-right">
             <i class="fa-solid fa-location-dot"></i>
           </div>
           <div class="col-10 float-left" style="margin: 5px 0;text-align: center">
             <div class="form-group">
               <input  v-model="addressnew" type="text" class="form-control text-center" name="mobile" >
             </div>
           </div>
         </div>
         <div class="clearfix"></div>
         <div class="col-12 address" style="margin: 5px 0">
           <div class="col-1 float-right">
             <i class="fa-light fa-mailbox"></i>
           </div>
           <div class="col-10 float-left" style="margin: 5px 0;text-align: center">
             <div class="form-group">
               <input  v-model="postalcode" type="text" class="form-control text-center"  placeholder="کدپستی" >
             </div>
           </div>
         </div>
         <div class="col-12 " style="margin: 5px 0">
           <div class="btn btn-success" style="margin: 5px auto;padding:  10px;width: 100%" @click="saveaddress" v-text="'ثبت ادرس'"></div>
         </div>
         <div class="clearfix"></div>
       </div>
       <div class="col-12 " v-if="type==2" style="border: 1px dashed #ccc">
         <div class="col-12" style="margin: 5px 0">
           <div class="col-4 float-right text-center" style="padding: 10px 0">
             نام:
           </div>
           <div class="col-7 float-right" style="padding: 10px 0">
             <input type="text" v-model="name" class="form-control"/>
           </div>
         </div>
         <div class="col-12" style="margin: 5px 0">
           <div class="col-4 float-right text-center" style="padding: 10px 0">
             نام خانوادگی:
           </div>
           <div class="col-7 float-right" style="padding: 10px 0">
             <input type="text" v-model="family" class="form-control"/>
           </div>
         </div>
         <div class="col-12" style="margin: 5px 0">
           <div class="col-4 float-right text-center" style="padding: 10px 0">
             موبایل:
           </div>
           <div class="col-7 float-right" style="padding: 10px 0">
             <input type="text" v-model="mobile"  class="form-control"/>
           </div>
         </div>
         <div class="col-12" style="margin: 5px 0">
           <div class="col-4 float-right text-center" style="padding: 10px 0">
             استان:
           </div>
           <div class="col-7 float-right" style="padding: 10px 0">
             <select class="form-select" v-model="stete_id" @change="getCity" >
               <option value="">انتخاب کنید</option>
               <template v-for="(stete_list, index)  in stete.data" :key="index">
                 <option  :value="stete_list.id" v-text="stete_list.fa"></option>
               </template>
             </select>
           </div>
         </div>
         <div class="clearfix"></div>
         <div class="col-12" style="margin: 5px 0">
           <div class="col-4 float-right text-center" style="padding: 10px 0">
             شهر:
           </div>
           <div class="col-7 float-right" style="padding: 10px 0">
             <select class="form-select" v-model="city_id">
               <option value="">انتخاب کنید</option>
               <template v-for="(stete_list, index)  in city.data" :key="index">
                 <option  :value="stete_list.id" v-text="stete_list.fa"></option>
               </template>
             </select>
           </div>

         </div>
         <div class="clearfix"></div>
         <div class="col-12 address" style="margin: 5px 0">
           <div class="col-1 float-right">
             <i class="fa-solid fa-location-dot"></i>
           </div>
           <div class="col-10 float-left" style="margin: 5px 0;text-align: center">
             <div class="form-group">
               <input  v-model="addressnew" type="text" class="form-control text-center" name="mobile" >
             </div>
           </div>
         </div>
         <div class="clearfix"></div>
         <div class="col-12 address" style="margin: 5px 0">
           <div class="col-1 float-right">
             <i class="fa-light fa-mailbox"></i>
           </div>
           <div class="col-10 float-left" style="margin: 5px 0;text-align: center">
             <div class="form-group">
               <input  v-model="postalcode" type="text" class="form-control text-center" placeholder="کدپستی" >
             </div>
           </div>
         </div>
         <div class="col-12 " style="margin: 5px 0">
           <div class="btn btn-success" style="margin: 5px auto;padding:  10px;width: 100%" @click="saveaddress" v-text="'ثبت ادرس'"></div>
         </div>
         <div class="clearfix"></div>
       </div>
     </div>
    <div v-if="allAddress.data.length>0">
      <div class="col-12 " style="text-align: right;border: 1px dashed #ccc">
          <label v-for="(basket, index)  in allAddress.data" :key="index">

            <div class="col-1  float-right ">
              <input type="radio" v-model="address_id"  name="address_id" @change="setCity(basket.city_id)">
            </div>
            <div class="col-11 float-right" v-html="basket.address_title"></div>

          </label>
        <div class="col-12 " style="margin: 5px 0">
          <div class="btn btn-success" style="margin: 5px auto;padding:  10px;width: 100%" @click="newaddress" v-text="'ثبت آدرس جدید'"></div>
        </div>
      </div>
    </div>
      <div v-if="address" class="address">
        <div class="col-1 float-right">
          <i class="fa-solid fa-location-dot"></i>
        </div>
        <div class="col-10 float-left" style="margin: 5px 0;text-align: right">
          <h6 v-text="address"></h6>
        </div>
      </div>
      <div class="clearfix"></div>
      <div v-if="address" class="address">
        <div class="col-1 float-right">
          <i class="fa-solid fa-location-dot"></i>
        </div>
        <div class="col-10 float-left" style="margin: 5px 0;text-align: right">
          <h4>دریافت حضوری</h4>
        </div>
      </div>
      <div class="clearfix"></div>
      <h2 style="text-align: center;color: #1fa29d;font-weight: 800">نحوه ارسال :</h2>
      <div class="clearfix"></div>
      <div class="col-12 sendP">
        <div class="col-3 float-right">
          <label>
            <v-img
          :src="require('../assets/tipax.png')"
          width="100%"


      />
            <input type="radio" name="send"  v-model="sendP" value="tipax">
          </label>
        </div>

        <div class="col-3 float-right">
          <label>
            <v-img
          :src="require('../assets/barbari.png')"
          width="100%"


      />
            <input type="radio" name="send" v-model="sendP" value="barbari">
          </label>
        </div>
        <div class="col-3 float-right" v-if="city_id==303">
          <label>
            <v-img
                :src="require('../assets/peack.jpg')"
                width="100%"


            />
            <input type="radio" name="send" v-model="sendP" value="peack">
          </label>
        </div>
      </div>
      <div class="clearfix"></div>
      <h2 style="text-align: center;color: #1fa29d;font-weight: 800;margin-top: 10px;margin-bottom: 10px">نحوه پرداخت :</h2>
      <div class="col-12  payType">
        <div class="col-3 float-right">
          <label>
            پرداخت آنلاین
            <div class="clearfix"></div>
            <input type="radio" name="payType"  checked v-model="payType" value="online">
          </label>
        </div>
        <div class="col-3 float-right">
          <label>
            پرداخت باچک
            <div class="clearfix"></div>
            <input type="radio" name="payType"  v-model="payType" value="check">
          </label>
        </div>
        <div class="col-3 float-right">
          <label>
            پرداخت نقدی
            <div class="clearfix"></div>
            <input type="radio" name="payType"  v-model="payType" value="many">
          </label>
        </div>
      </div>
      <div class="clearfix"></div>
      <div v-if="payType=='check'" style="border: 1px dashed;margin: 10px auto;padding: 10px" class="col-12">
        <div class="form-group">
          <label>
            شماره صیادی چک
            <input type="text" class="form-control" v-model="checkNo">
          </label>
        </div>
        <div class="form-group">
          <label>
            شماره چک
            <input type="text" class="form-control" v-model="checkNo1">
          </label>
        </div>
        <div class="form-group">
          <label>
            تاریخ چک
            <input type="text" class="form-control" v-model="checkDate">
          </label>
        </div>
        <div class="form-group">
          <label>
            نام بانک
            <input type="text" class="form-control" v-model="checkBank">
          </label>
        </div>
      </div>
      <div class="clearfix"></div>
      <h2 style="text-align: center;color: #1fa29d;font-weight: 800;margin-top: 10px;margin-bottom: 10px">دریافت فاکتور :</h2>
      <div class="col-12  payType">
        <div class="col-3 float-right">
          <label>
            فاکتور رسمی
            <div class="clearfix"></div>
            <input type="radio" name="facktor"  v-model="facktor" value="1">
          </label>
        </div>
        <div class="col-3 float-right">
          <label>
            فاکتور شرکتی
            <div class="clearfix"></div>
            <input type="radio" name="facktor"  v-model="facktor" value="2">
          </label>
        </div>
        <div class="col-3 float-right">
          <label>
            نیاز به فاکتور ندارم
            <div class="clearfix"></div>
            <input type="radio" name="facktor" checked v-model="facktor" value="3">
          </label>
        </div>
      </div>
      <div class="clearfix"></div>
      <h2 style="text-align: center;color: #1fa29d;font-weight: 800;margin-top: 10px;margin-bottom: 10px">لیست سفارشات :</h2>
      <div class="clearfix"></div>
      <div  style="border: 1px dashed;margin: 10px auto;padding: 10px" class="col-12">
        <cart-view :show="true"></cart-view>
      </div>
      <div style="position: fixed;width: 300px;margin: 0 auto;bottom: 60px;height: 180px;border-radius: 10px 10px 0 0;background: #1fa29d;padding: 10px;text-align: center">
        <div style="font-size: 12pt;color: #fff">جمع کل با هزینه ارسال  : {{baskets.data.priceTotalChShow}} ریال</div>
        <hr style="color: #fff"/>
        <div style="font-size: 12pt;color: #fff">مبلغ قابل پرداخت : {{baskets.data.priceTotalChShow}} ریال</div>

          <div style="font-size: 15pt;color: #1fa29d;padding: 5px;background: #fff;margin-top: 10px;border-radius: 10px;font-weight: 800" @click="err">ثبت سفارش</div>
      </div>
    </div>
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">حذف از سبد خرید</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            آیا از حذف این مورد اطمینان دارید؟
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">خیر</button>
            <button type="submit" class="btn btn-danger">بله</button>
          </div>
        </div>
      </div>
    </div>
  </v-main>
  <footer-app></footer-app>
</template>

<script >
import {defineComponent} from "vue";
import HeaderApp from "@/views/headerApp.vue";
import FooterApp from "@/views/FooterApp.vue";
import http from "@/plugins/axios";
import router from "@/router";
import axios, {formToJSON} from "axios";
import CartView from "@/views/Cartview.vue";
var numeral = require("numeral");
export default defineComponent({
  name: 'checkout-show',
  components: {CartView, FooterApp, HeaderApp},
  data: () => ({
    facktor : 3,
    checkBank:"",
    checkNo:"",
    checkNo1:"",
    checkDate:"",
    check:"",
    name:"",
    family: "",
    mobile:"",
    dialog: true,
    stete_id :null,
    city_id :null,
    address_id : 0,
    payType: "online",
    type :0,
    addressnew : "",
    sendP : "tipax",
    address: localStorage.getItem("address"),
    baskets :  {
      data: [],
      total: [],
    },
    stete :{
      data : [],
    },
    city :{
      data : [],
    },
    allAddress:{
      data : [],
    },
    sum : 1000,
    postalcode : "",

  }),
  methods: {
    setCity(city_id){
      this.city_id = city_id;
    },
    newaddress(){
      this.allAddress.data=[];
    },
    getCity(){
      http.get("/states/city/"+this.stete_id)
          .then(response => {
            this.city = response.data;

          })
          .catch((error) => {
          });
    },
    getUser(){
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.post("/user",'',{ headers: { Authorization: AuthStr } })
          .then(response => {
            this.name = response.data.data.name;
            this.family = response.data.data.family;
            this.mobile = response.data.data.phone;
          })
          .catch((error) => {
          });
    },
    gatewaySend(){
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/orders?price="+this.baskets.data.priceTotalCh,{ headers: { Authorization: AuthStr } })
          .then(response => {
            // window =
            alert("درحال اتصال به درگاه بانک");
            window.location.href ="https://bitpay.ir/payment/gateway-"+response.data.data+"-get"
            // console.log(response.data.data);
          })
          .catch((error) => {
          });

    },
    getAddress(){
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/address/get-all/"+this.type,{ headers: { Authorization: AuthStr } })
          .then(response => {
            this.allAddress = response.data
          })
          .catch((error) => {
          });
    },
    settype(n){

      this.type=n;
      this.stete_id = null;
      this.city_id = null;
      this.getAddress();
      if(n==1){
        this.getUser();
        $(".type1").addClass("active");
        $(".type2").removeClass("active");
      }else {
        this.name="";
        this.family="";
        this.mobile="";
        $(".type1").removeClass("active");
        $(".type2").addClass("active");
      }
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("states")
          .then(response => {
            this.stete = response.data;

          })
          .catch((error) => {
          });
    },
    saveaddress(){
      if(this.name!="" && this.mobile!="" && this.mobile!="" && this.addressnew!="" && this.postalcode!=""){
        const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
        http.post("/address/add",{
          name : this.name,
          family : this.family,
          mobile : this.mobile,
          state_id : this.stete_id,
          city_id : this.city_id,
          postcode : this.postalcode,
          address : this.addressnew,
          type : this.type,
        },{ headers: { Authorization: AuthStr } })
            .then(response => {
              if(response.data.data.city_id==this.city_id){
                alert("ادرس با موفقیت ثبت شد");
                this.getAddress()
              }
            })
            .catch((error) => {
            });
      }else {
        alert("پرکردن همه موارد الزامی هست")
      }

    },
    err(){
      if(this.address_id==0){
        alert("متاسفانه ادرسی آنتخاب نشده است ")
      }
      if(this.sendP==""){
        alert("نحوه ارسال را انتخاب کنید ")
      }else{
        if(this.payType=="online")
          this.gatewaySend();
        else
          alert("ثبت سفارش ما با موفقیت انجام شد پس تایید فروشگاه به شما اطلاع خواهد داده شد");
      }

    },
    setadd(){
      localStorage.setItem("address",this.addressnew);
      this.address = this.addressnew;
    },
    getCart() {
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/basket/get", { headers: { Authorization: AuthStr } })
          .then(response => {
            this.baskets = response.data;
            this.dialog= false;
            console.log( this.baskets.data);
          })
          .catch((error) => {
          });
    },
  },
  mounted() {
    this.getCart();
  },
});
</script>



<style scoped>
.active div{
  background: #0f625d !important;
}
.addG{
  padding: 5px;
}
.addG div{

  background: #1fa29d;
  border-radius: 10px;
  color: #fff !important;
  padding: 15px;
}
.main{
  padding: 60px 0 60px;
  height: calc(100% +100px);
  direction: rtl;
}
table{
  width: 90%;
  margin: 0 auto;
}
table tr td{
  padding: 5px;
  text-align: center;
}
.del i{
  color: #7a0606;
  font-size: 18pt;
}
.item{
  overflow: hidden;
}
.item div{
  align-content: center;
  padding: 5px;
}
.deleteItem{
  background: #7a0606;
}
.deleteItem i{
  color: #fff;
}
a{
  text-decoration: none;
}
.uint_title{
  font-size: 7pt;
}
.address{
  padding: 10px;
}
.address i{
  color:#000;
  font-size: 24pt;
}
label{
  width: 100%;
  min-height: 100px;
  vertical-align: center;
}
label img{}

.payType .col-3{
  margin: 0 10px;
}
.payType .col-3{
  text-align: center;
  border: 1px dashed;
  min-height: 55px;
}
.main{
  padding-bottom: 350px;
}
</style>